import * as React from 'react';
export function useControllableState({ value, defaultValue, onChange, }) {
    const isControlled = value !== undefined;
    const [stateValue, setStateValue] = React.useState(defaultValue);
    const val = (isControlled ? value : stateValue);
    const onValueChange = React.useCallback((nextValue) => {
        if (!isControlled)
            setStateValue(nextValue);
        if (onChange)
            onChange(nextValue);
    }, [onChange, isControlled]);
    return [val, onValueChange];
}
//# sourceMappingURL=useControllableState.js.map